import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useAuth } from '../../../../utils/Auth';
import styles from './Appointment.module.css';

const Appointment = () => {
    const { qr_data, dataDispatch } = useAuth();

    return (
        <div className={styles.container}>
            <div className={styles.inputGroup}>
                <input type='url' id='appointment-label' className={styles.input} onChange={e => dataDispatch({type: 'redirect', data: e.target.value})} value={qr_data?.data?.redirect_url} />
                <label htmlFor='appointment-label' className={styles.label} style={{marginRight:'0.5rem'}}>eg. Calendly (URL)</label>
                <OverlayTrigger
                    placement='top'
                    delay={{show: 250, hide: 400}}
                    trigger={["click", "hover"]}
                    overlay={<Tooltip><p>URL must be a Calendly or Google Calendar link.</p></Tooltip>}
                >
                    <h5 className={styles.info}><i className="fa-regular fa-circle-info"></i></h5>
                </OverlayTrigger>
            </div>   
        </div>
    );
};

export default Appointment;